import JChartBarSolid from './Control_Charts'
export { JChartBarSolid }
export default JChartBarSolid